import { render, staticRenderFns } from "./ValidationStatusMobile.vue?vue&type=template&id=aaa8a5c0"
import script from "./ValidationStatusMobile.vue?vue&type=script&lang=js"
export * from "./ValidationStatusMobile.vue?vue&type=script&lang=js"
import style0 from "./ValidationStatusMobile.vue?vue&type=style&index=0&id=aaa8a5c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports